import React, { useEffect } from "react";
import { useState } from "react";

const DailySales = () => {
  const Category = [
    {
      id: 1,
      name: "Mountain Due",
      category: "Beverage",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
    {
      id: 2,
      name: "Mountain Due",
      category: "Beverage",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
    {
      id: 3,
      name: "Mountain Due",
      category: "pepsi",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
    {
      id: 4,
      name: "Mountain Due",
      category: "cocacola",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
    {
      id: 5,
      name: "Mountain Due",
      category: "fanta",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
    {
      id: 6,
      name: "mojo",
      category: "sprite",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
    {
      id: 7,
      name: "apple",
      category: "Beverage",
      barCode: "E-83234254",
      supplier: "Pran",
      purchasePrice: "10tk",
      salesPrice: "15tk",
      purchaseDate: "10 June Fri 2022",
    },
  ];

  const [info, Setinfo] = useState([]);
  const [query, Setquery] = useState([]);

  useEffect(() => {
    Setinfo(Category);
  }, []);

  // console.log(info);

  const Searcing = (e) => {
    let result = e.target.value;
    Setquery(result);
    // console.log(info.filter(data=>data.name.toLowerCase().includes(result)));
  };

  return (
    <div className="m-5">
      <div className="flex justify-between ">
        <div>
          <h1 className="text-2xl mt-2">Daily Sales</h1>
        </div>
        <div>
          {" "}
          <input
            onChange={(e) => {
              Searcing(e);
            }}
            type="text"
            placeholder="SEarch Category"
            class="input input-bordered border-l-0 input-sm w-full"
          />
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class=" mt-5 table table-compact w-full">
          <thead>
            <tr>
              <th>SL</th>
              <th>Product Name</th>
              <th>Category Name</th>
              <th>Bar code</th>
              <th>Sales Price</th>
              <th>Sales Date tIME</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {info
              .filter((item) => item.category.toLowerCase().includes(query))
              .map((item) => (
                <tr>
                  <th>{item.id}</th>
                  <td>{item.name}</td>
                  <td>{item.category}</td>
                  <td>{item.barCode}</td>
                  <td>{item.salesPrice}</td>
                  <td>5-7-22</td>
                  <td>
                    5<span>piace</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <div className="flex justify-between mt-5">
          <div>
            <h1></h1>
          </div>
          <div>
            <button class="btn btn-wide">
              {" "}
              Get Report Downlod
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 m-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailySales;
